import type { TableFilterDto } from "@gatiq/shared";

const ACTION_LABELS: Record<string, string> = {
  org_create: "Organization created",
  org_update: "Organization updated",
  org_suspend: "Organization suspended",
  org_activate: "Organization activated",
  org_delete: "Organization deleted",
  platform_branding_update: "Platform branding updated",
  org_branding_update: "Organization branding updated",
  org_branding_reset: "Organization branding reset",
  org_settings_update: "Organization settings updated",
  depot_create: "Depot created",
  depot_update: "Depot updated",
  depot_delete: "Depot deleted",
  product_create: "Product created",
  product_update: "Product updated",
  user_create: "Person added",
  user_update: "Person updated",
  user_delete: "Person removed",
  user_suspend: "Person suspended",
  user_role_change: "Person's role changed",
  karigar_transfer: "Karigar transferred",
  reward_batch_issue: "Reward codes issued",
  reward_batch_void: "Reward batch withdrawn",
  reward_code_update: "Reward code updated",
  reward_code_reverse: "Scan reversed",
  redemption_settle: "Redemption paid",
  counter_reimburse: "Counter reimbursed",
  kyc_submit: "Karigar profile submitted",
  kyc_approve: "Karigar approved",
  kyc_reject: "Karigar rejected",
  promo_broadcast: "WhatsApp message sent",
  dispatch_create: "Stock dispatched",
  dispatch_undo: "Stock dispatch undone",
  login_success: "Signed in",
  login_failed: "Sign-in failed",
  password_changed: "Password changed",
  impersonation_start: "Support access started",
  impersonation_end: "Support access ended",
  whatsapp_link: "WhatsApp connected",
  whatsapp_unlink: "WhatsApp disconnected",
  whatsapp_config_update: "WhatsApp settings updated",
  platform_settings_update: "Platform settings updated",
  reward_scheme_create: "Reward scheme created",
  reward_scheme_update: "Reward scheme updated",
  reward_scheme_delete: "Reward scheme deleted",
  document_create: "Document published",
  document_update: "Document updated",
  document_delete: "Document withdrawn",
};

const ENTITY_LABELS: Record<string, string> = {
  user: "Person",
  organization: "Organization",
  product: "Product",
  reward_batch: "Reward batch",
  reward_code: "Reward code",
  redemption: "Redemption",
  settlement: "Counter reimbursement",
  dispatch: "Stock dispatch",
  document: "Document",
  whatsapp: "WhatsApp",
};

function words(value: string): string {
  const readable = value.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").trim();
  return readable ? readable[0]!.toUpperCase() + readable.slice(1) : "Unknown";
}

export function auditActionLabel(value: string): string {
  return ACTION_LABELS[value] ?? words(value);
}

export function auditEntityLabel(value: string | null): string {
  return value ? ENTITY_LABELS[value] ?? words(value) : "Not specified";
}

export function auditFilterLabels(definitions: TableFilterDto[] = []): TableFilterDto[] {
  const labels: Record<string, string> = {
    actorRole: "Who performed it",
    action: "Activity",
    entityType: "Affected record",
  };
  return definitions.map((definition) => ({
    ...definition,
    label: labels[definition.key] ?? definition.label,
    options: definition.options.map((option) => ({
      ...option,
      label: option.value === "__none" ? "Not specified"
        : definition.key === "action" ? auditActionLabel(option.value)
        : definition.key === "entityType" ? auditEntityLabel(option.value === "__none" ? null : option.value)
          : option.label,
    })).sort((a, b) => a.label.localeCompare(b.label)),
  }));
}
